import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import { AdPicture } from './ad';

interface useAdsProps {
  object: string;
  display: string;
  enabled?: boolean;
}

export function useAds({object, display, enabled = true} : useAdsProps) {
  return useQuery({
    queryKey: ['ads'],
    queryFn: () => fetchAds({object, display}),
    staleTime: 0,
    refetchInterval: 0,
    enabled
  });
}

function fetchAds({object, display} : useAdsProps): Promise<AdPicture> {
  return apiClient.get(`ads/${object}/${display}`).then(response => response.data);
}
